import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { useService } from 'shared/providers';
import { DynamicEmailData } from 'shared/services/email-address-service';
import { useAuthState } from 'shared/stores';
import { NeedsApprovalEmailData } from 'types/backend';

export function useSendDeviationNeedsApprovalEmail(
    url: string,
    dynamicEmailData: Omit<DynamicEmailData, 'currentUserName' | 'currentUserEmailAddress'>
) {
    const { notificationService } = useService();
    const { enqueueSnackbar } = useSnackbar();

    const authState = useAuthState();
    const currentUser = authState.user.get();
    const currentUserEmailAddress = currentUser?.email! || '';
    const currentUserName = currentUser?.displayName || '';

    const allDynamicEmailData: DynamicEmailData = {
        ...dynamicEmailData,
        currentUserName,
        currentUserEmailAddress,
    };

    return useMutation<void, Error, NeedsApprovalEmailData[]>(
        (request) => {
            if (request.length === 0) return Promise.resolve();

            return notificationService.sendDeviationNeedsApprovalEmail(request, url, allDynamicEmailData);
        },
        {
            onSuccess: (_, variables) => {
                enqueueSnackbar(`An approval email has been sent `, {
                    variant: 'success',
                });
            },
            onError: (data) => {
                enqueueSnackbar(data.message, { variant: 'error' });
            },
        }
    );
}
